export default "__VITE_ASSET__f8a442e7__"